import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#3cdd94",
      contrastText: "#000",
    },
    text: {
      primary: "rgba(0,0,0,0.87)",
      secondary: "rgba(0,0,0,0.6)",
    },
  },

  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          textAlign: "left",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
        text: ({ theme }) => ({
          color: theme.palette.text.primary,
        }),
        outlined: ({ theme }) => ({
          color: theme.palette.text.primary,
          borderColor: theme.palette.divider,
        }),
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontWeight: 400,
          fontSize: "18px",
          lineHeight: 1.4,
          color: `${theme.palette.text.primary} !important`,
          marginBottom: "24px",
        }),
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          paddingLeft: "18px",
          display: "flex",
          gap: "12px",
        },
      },
    },
  },
});

export default theme;
